import { createApiClient } from './ApiClientFactory';

const BASE_URL = import.meta.env.VITE_BASE_URL || 'http://localhost:5000';
const apiClient = createApiClient(BASE_URL + '/projects');

export default {

    async getProjects(params = {}) {
        const response = await apiClient.get('/', { params });
        return response.data;
    },

    async getProjectStats(params = {}) {
        const response = await apiClient.get('/stats', { params });
        return response.data;
    },

    async getProject(projectId) {
        const response = await apiClient.get(`/${projectId}`);
        return response.data;
    },

    async createProject(payload) {
        const response = await apiClient.post('/', payload);
        return response.data;
    },

    async updateProject(projectId, payload) {
        const response = await apiClient.put(`/${projectId}`, payload);
        return response.data;
    },

    async archiveProject(projectId) {
        const response = await apiClient.patch(`/${projectId}/archive`);
        return response.data;
    },

    async deleteProject(projectId) {
        const response = await apiClient.delete(`/${projectId}`);
        return response.data;
    },
}